import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { DashboardLayout } from "../../../components/organisms/Layout";
import AddAddressContent from "../../../components/AddAddressContent";

const AddAddress = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const editMode = location.pathname.search("edit") !== -1;

  useEffect(() => {
    if (editMode) {
      document.title = "HeyHire Portal-Edit Address";
    } else {
      document.title = "HeyHire Portal-Add New Address";
    }
  }, []);

  return (
    <DashboardLayout >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center">
            <Link to="/admin/address-book" className="mr-3">
              <i className="far fa-chevron-left text-xl text-gray-500 hover:text-gray-700 transition-colors" />
            </Link>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                {editMode
                  ? t("address-book.edit-address")
                  : t("address-book.add-address")}
              </h2>
              <p className="mt-1 text-sm text-gray-600">
                {editMode
                  ? t(
                      "address-book.edit-address-description",
                      "Update the address information below."
                    )
                  : t(
                      "address-book.add-address-description",
                      "Fill in the information below to add a new address."
                    )}
              </p>
            </div>
          </div>
        </div>
        <AddAddressContent />
      </div>
    </DashboardLayout>
  );
};

export default AddAddress;
